import { CRONOFY_CHECK_CALENDAR_PERMISSIONS } from '@/gql/cronofy';
import { CronofyCheckCalendarPermissionsPayload, CronofyCheckCalendarPermissionsResponse } from '@/gql/cronofy/types';
import { fetchData } from '@/services/graphql';
import { useQuery } from '@tanstack/react-query';

const useCronofyCheckCalendarPermissions = (calendarIds: string[], enabled: boolean = true) => {
  return useQuery({
    queryKey: ['cronofy', 'calendar-permissions', calendarIds],
    queryFn: () =>
      fetchData<CronofyCheckCalendarPermissionsResponse>(CRONOFY_CHECK_CALENDAR_PERMISSIONS, {
        calendarIds,
      } as CronofyCheckCalendarPermissionsPayload),
    select: (data) => data?.cronofyCalendarPermissions?.calendars,
    enabled: enabled && calendarIds.length > 0,
  });
};

export default useCronofyCheckCalendarPermissions;
